import UpdateAdd from "./UpdateAdd";
export default {
  name: "OverlayWrapper",
  components: {
    UpdateAdd: UpdateAdd
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    show: {
      type: Boolean,
      default: false
    },
    isSlot: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    coverImgUrl: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    titleInfo: function titleInfo() {
      if (this.title) {
        return this.title;
      } else if (this.item.addr) {
        return "确认信息";
      }
    }
  },
  methods: {}
};